import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTrigger,
} from "../../../../../components/ui/alert-dialog";
import { useEditTablesController } from "./useEditTablesController";
import { Button } from "@/view/components/ui/button";
import { Commission } from "@/app/entities/Team";
import {
  CommissionForm,
  CommissionType,
} from "@/view/components/CommissionForm";
import { useAuth } from "@/app/hooks/useAuth";
import { UserRoleEnum } from "@/app/services/usersService/user";

interface EditTablesProps {
  commission: Commission[];
  supervisorId?: string;
}

export const EditTables = ({ commission, supervisorId }: EditTablesProps) => {
  const {
    open,
    setOpen,
    handleChange,
    handleSave,
    isPending,
    commissionWithMax,
    productsConfig,
    hasValidationError,
  } = useEditTablesController(commission, supervisorId);

  const { user } = useAuth();
  const userRole = user?.role;

  const canEdit =
    userRole === UserRoleEnum.SUPER_ADMIN || userRole === UserRoleEnum.ADMIN;

  const getVisibleCommissions = (): CommissionType[] => {
    switch (userRole) {
      case UserRoleEnum.SUPER_ADMIN:
      case UserRoleEnum.ADMIN:
      case UserRoleEnum.MANAGER:
      case UserRoleEnum.SUPERVISOR:
        return ["supervisor", "leader", "seller"];
      case UserRoleEnum.LEADER:
        return ["leader", "seller"];
      case UserRoleEnum.USER:
      default:
        return ["seller"];
    }
  };

  const visibleCommissions = getVisibleCommissions();
  const buttonText = canEdit ? "Configurar comissões" : "Visualizar comissões";

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="outline" className="w-full">
          {buttonText}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-h-[90vh] w-[700px] max-w-[95vw] overflow-hidden p-0">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (canEdit) {
              handleSave();
            }
          }}
          className="flex h-full max-h-[90vh] min-w-0 flex-col"
        >
          <div className="border-b-[1px] border-white02" />

          <div className="min-w-0 flex-1 overflow-y-auto p-4">
            <CommissionForm
              commission={commissionWithMax}
              onChange={canEdit ? handleChange : undefined}
              readOnly={!canEdit}
              visibleCommissions={visibleCommissions}
              productsConfig={productsConfig}
              userRole={userRole}
            />
          </div>

          <AlertDialogFooter className="flex-shrink-0 space-x-2 border-t-[1px] border-white02 p-5">
            <AlertDialogCancel className="rounded-full bg-white02">
              {canEdit ? "Cancelar" : "Fechar"}
            </AlertDialogCancel>
            {canEdit && (
              <Button
                disabled={isPending || hasValidationError}
                type="submit"
                className="rounded-full bg-primary font-semibold text-white"
              >
                Salvar alterações
              </Button>
            )}
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  );
};
